import { withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { compose } from 'recompose';
import { debounce } from '../../../../utils/debounce';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../components/Common/Arrows/Arrows';

const styles = theme => ({
    listContainer: {
        overflow:'hidden',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
    },
    cardsContainer: {
        height: '100%',
        display: 'flex',
        width: '100%',
        overflowX: 'hidden',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
})

class LibrarySectionList extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            reachRightEnd: false,
            reachLeftEnd: false,
        }
        this.listRef = React.createRef();
        this.intervId = 0;
    }

    hideRightArrow() {
        const { scrollWidth, offsetWidth, scrollLeft } = this.listContainer
        const reachEnd = scrollWidth - (offsetWidth + scrollLeft) < 10
        return reachEnd
    }

    hideLeftArrow() {
        const reachEnd = this.listContainer.scrollLeft < 10
        return reachEnd
    }

    scrollToRight = () => {
        this.debouncedSave(1);
    }
    scrollToLeft = () => {
        this.debouncedSave(-1);
    }

    componentWillUnmount() {
        clearInterval(this.intervId)
    }
    debouncedSave = debounce((factor) => this.scrollTo(factor), 500)
    scrollTo(factor) {
        const scrollWidth = this.listContainer.firstElementChild.clientWidth + 10
        this.listContainer.scrollBy({
            top: 0,
            left: this.props.storiesList ? 123 * factor : scrollWidth * factor * this.props.screenSize,
            behavior: 'smooth'
        })
    }

    onScroll = () => {
        const reachRightEnd = this.hideRightArrow()
        const reachLeftEnd = this.hideLeftArrow()

        if (this.state.reachLeftEnd != reachLeftEnd ||
            this.state.reachRightEnd != reachRightEnd) {
            this.setState({ reachLeftEnd, reachRightEnd })
        }
    }

    initReachEnd = () => {
        const { scrollWidth, offsetWidth } = this.listContainer

        if (scrollWidth == offsetWidth) {
            this.setState({ reachLeftEnd: true, reachRightEnd: true })
        } else {
            this.setState({ reachLeftEnd: true, reachRightEnd: false })
        }
    }

    componentDidUpdate(preProps) {
        if (this.listRef.current && preProps.children.length != this.props.children.length) {
            this.initReachEnd()
        }
    }

    componentDidMount() {
        this.listContainer = this.listRef.current
        this.initReachEnd()
    }

    renderListControlButtons = () => {
        const {controlStyles} = this.props
        const { reachLeftEnd, reachRightEnd } = this.state;
        return (
            <div data-intrcm-id="LibrarySectionList_b7inurui" className={controlStyles.controlWrap}>
                <div data-intrcm-id="LibrarySectionList_j9llc8gn" className={controlStyles.controlButtons}>
                    <button className={controlStyles.leftButton} onClick={this.scrollToLeft}>
                        <ArrowLeftIcon 
                            backgroundColor={controlStyles.arrowBg}
                            className={!reachLeftEnd ? controlStyles.activeIcon: controlStyles.disableIcon}/>
                    </button>
                    <button className={controlStyles.rightButton} onClick={this.scrollToRight}>
                        <ArrowRightIcon
                            backgroundColor={controlStyles.arrowBg}
                            className={!reachRightEnd ? controlStyles.activeIcon: controlStyles.disableIcon}/>
                    </button>
                </div>
            </div>
        )
    }


    render() {
        const { classes, children, listContainerStyle, cardsContainerStyle, hideControl } = this.props;

        return (
            <div data-intrcm-id="LibrarySectionList_veiqxn6q" className={[classes.listContainer, listContainerStyle].join(" ")} >
                <div data-intrcm-id="LibrarySectionList_u1k38wef" className={[classes.cardsContainer, cardsContainerStyle].join(" ")} ref={this.listRef} onScroll={this.onScroll}>
                    {children}
                </div>
                {!hideControl && this.renderListControlButtons()}
            </div>
        )
    }
}

export default compose(withStyles(styles))(LibrarySectionList);

